import React from "react";

interface StatusProps {
  status: string;
}

const statusMap: Record<
  string,
  { label: string; color: string; bg: string }
> = {
  // Audit Statuses
  ongoing: {
    label: "In Progress",
    color: "#3B82F6",
    bg: "#E3F0FF",
  },
  completed: {
    label: "Completed",
    color: "#0E9F6E",
    bg: "#E8F8F4",
  },
  upcoming: {
    label: "Upcoming",
    color: "#9a3412",
    bg: "#ffedd5",
  },
  due: {
    label: "Due",
    color: "#EE3043",
    bg: "#fee2e2",
  },
  ended: {
    label: "Ended",
    color: "#EE3043",
    bg: "#FFF5F8",
  },
  deactivated: {
    label: "Deactivated",
    color: "#5A5A5A",
    bg: "#F6F6F6",
  },
  
  // Vulnerability Severity Levels
  critical: {
    label: "Critical",
    color: "#EE3043",
    bg: "#fee2e2",
  },
  high: {
    label: "High",
    color: "#9a3412",
    bg: "#ffedd5",
  },
  medium: {
    label: "Medium",
    color: "#3B82F6",
    bg: "#E3F0FF",
  },
  low: {
    label: "Low",
    color: "#0E9F6E",
    bg: "#E8F8F4",
  },
  info: {
    label: "Info",
    color: "#0E9F6E",
    bg: "#E8F8F4",
  },
  
  // Vulnerability Statuses
  open: {
    label: "Open",
    color: "#EE3043",
    bg: "#fee2e2",
  },
  resolved: {
    label: "Resolved",
    color: "#0E9F6E",
    bg: "#E8F8F4",
  },
  ignored: {
    label: "Ignored",
    color: "#5A5A5A",
    bg: "#F6F6F6",
  },
  snoozed: {
    label: "Snoozed",
    color: "#9a3412",
    bg: "#ffedd5",
  },
  closed: {
    label: "Closed",
    color: "#5A5A5A",
    bg: "#F6F6F6",
  },
};

export const Status: React.FC<StatusProps> = ({ status }) => {
  const normalized = (status || "").toLowerCase();
  const style = statusMap[normalized];

  if (!style) return null; 

  return (
    <span
      className="badge fs-8 fw-semibold m-1"
      style={{
        background: style.bg,
        color: style.color,
        borderRadius: 6,
        padding: "4px 8px",
      }}
    >
      {style.label}
    </span>
  );
};